module.exports = __webpack_public_path__ + "ac2d832b7cae308d42239e1ccbfae967.png";